import { render, staticRenderFns } from "./AssessmentBody.vue?vue&type=template&id=101fde8e&scoped=true"
import script from "./AssessmentBody.vue?vue&type=script&lang=ts"
export * from "./AssessmentBody.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentBody.vue?vue&type=style&index=0&id=101fde8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101fde8e",
  null
  
)

export default component.exports